var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1301,
    height: 1505,
    viewBox: "0 0 1301 1505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "homepage_graphic-a",
    width: 1306,
    height: 1505,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(180 651 752.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "homepage_graphic-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#homepage_graphic-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#homepage_graphic-b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-176 2034.212 2465.92)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D8DCDC",
    points: ".197 8478.436 6979.36 8927.033 4010.487 3556.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F6B9A",
    points: "2044.196 .397 4010.487 3556.99 6666.513 297.504"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#543D80",
    points: "4010.487 3556.99 6979.36 8927.033 8147.774 9002.133 8649.091 424.937 6666.514 297.505"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageGraphic);
export default __webpack_public_path__ + "static/media/homepage_graphic.5bb74be0270edeb3e0f04f367a101d13.svg";
export { ForwardRef as ReactComponent };